import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FormGroup } from 'react-bootstrap';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import Loader from '../../../../../Components/Utility/Loader/Loader';
import { customStyles } from '../../../../../Components/helper';

const optionArray = [
  { _id: 1, name: 'Approved' },
  { _id: 2, name: 'Rejected' },
  { _id: 3, name: 'Not Applicable' },
];

function EditDocumentDetails({ onOpen, toggle, data, handleSubmit, loading, showErr }) {
  const [state, setState] = useState({
    status: null,
    isVisibleToSupplier: false,
    notes: '',
    docName: '',
  });

  const onStatusChange = (e) => {
    setState((stated) => ({
      ...stated,
      status: e,
    }));
  };

  const setStatus = () => {
    const statuses = optionArray.filter((ele) => ele.name === data?.status);
    return statuses[0];
  };
  useEffect(() => {
    setState((effectSattus) => ({
      ...effectSattus,
      docName: data?.fileName,
      isVisibleToSupplier: data?.isVisibleToSupplier,
      notes: data?.notes,
      status: setStatus(),
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const inputChange = (e) => {
    if (e?.target?.name === 'docName') {
      setState((previousNames) => ({
        ...previousNames,
        docName: e.target.value,
      }));
    } else {
      setState((previousNotes) => ({
        ...previousNotes,
        notes: e.target.value,
      }));
    }
  };
  const { t } = useTranslation('common');

  return (
    <Modal show={onOpen} backdrop="static" className="custom-modal modal-medium" aria-labelledby="contained-modal-title-vcenter" onHide={toggle}>
      <Modal.Header>
        <div className="d-flex justify-content-between align-items-center w-100">
          <Modal.Title id="contained-modal-title-vcenter">
            <span>{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.EDIT_DOCUMENT_DETAIL.EDIT_DOCUMENT')}</span>
          </Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        {loading && <Loader />}
        {!loading && (
          <div className="justify-content-between">
            <div className="product-costing-filter">
              <FormGroup className="mb-2">
                <div className="input-group form-floating-label fixed-label">
                  <input name="docName" value={state.docName} onChange={inputChange} type="text" className="form-control" />
                  <label className="asterisk-req">{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.EDIT_DOCUMENT_DETAIL.DOCUMENT_NAME')}</label>
                </div>
                {showErr && (
                  <small className="error-message">
                    {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.EDIT_DOCUMENT_DETAIL.PLEASE_ENTER_DOCUMENT_TITLE')}
                  </small>
                )}
              </FormGroup>
              <FormGroup className="mb-2">
                <div className="input-group form-floating-label fixed-label">
                  <input name="notes" value={state.notes} onChange={inputChange} type="text" className="form-control" />
                  <label className="asterisk-req">{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.EDIT_DOCUMENT_DETAIL.NOTES')}</label>
                </div>
              </FormGroup>
              <FormGroup className="mb-2">
                <div className="custom-react-select ">
                  <label className="select-label">{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.EDIT_DOCUMENT_DETAIL.STATUS')}</label>
                  <Select
                    options={optionArray}
                    maxMenuHeight={132}
                    menuPlacement="bottom"
                    menuPosition="relative"
                    getOptionLabel={(e) => `${e?.name}`}
                    getOptionValue={(e) => `${e?._id}`}
                    onChange={(e) => onStatusChange(e)}
                    styles={customStyles}
                    value={state.status}
                    placeholder={t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.EDIT_DOCUMENT_DETAIL.SELECT_STATUS')}
                  />
                </div>
              </FormGroup>
            </div>
            <div className="modal-buttons mt-3 d-flex justify-content-between">
              <button type="button" onClick={toggle} className="btn btn-default">
                {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.EDIT_DOCUMENT_DETAIL.CANCEL')}
              </button>
              <button type="button" className="btn btn-default" onClick={() => handleSubmit(state)}>
                {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.EDIT_DOCUMENT_DETAIL.SUBMIT')}
              </button>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default EditDocumentDetails;
